import AboveSheet from './AboveSheet';

/** 시트 윗변 바깥에 띄우는 보유 코인 배지 (예전 .mycoins-box 모양) */
const MyCoinsBadge = ({ coins }: { coins: number }) => (
  <AboveSheet>
    <div dir="ltr" className="flex h-10 w-[103px] items-center justify-evenly rounded-[20px] bg-black text-white shadow-[0_2px_4px_rgba(0,0,0,0.12)]">
      <img src="/imgweb/main/coin.png" alt="" className="h-[23px] w-[23px]" />
      <span>{coins}</span>
    </div>
  </AboveSheet>
);

export default MyCoinsBadge;
